module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('footer', {
    staticClass: "more-information"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('h2', {
    attrs: {
      "data-aos": "fade-up",
      "data-aos-delay": "100"
    }
  }, [_vm._v(_vm._s(_vm.$t('component.moreInfo')))]), _vm._v(" "), _c('div', {
    staticClass: "btn-hover"
  }, [_c('a', {
    staticClass: "btn red-border",
    attrs: {
      "data-aos": "fade-up",
      "data-aos-delay": "200"
    },
    on: {
      "click": function($event) {
        _vm.showModal()
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('component.askAboutMore')) + " "), _c('span')])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-176b8aac"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/FooterMoreInformation.vue
// module id = 278
// module chunks = 0